import React from 'react';
import { BiLoader } from 'react-icons/bi';
import { MdCloudDownload } from 'react-icons/md'
import styles from './InputFile.module.scss';

export default function InputFile({ onChange , name , label , ref , isLoading , withErrors , error  }) {

  return (
    <div className={styles.container}>
      <label>{label}</label>
      {isLoading ?
        <label className={styles.btn}>
          <div className={styles.loader}><BiLoader size={20} color={'#FFFFFF'} /></div>
          Traitement en cours
        </label>
      :
        <label htmlFor={name} className={styles.btn}>
          <MdCloudDownload size={20} color={'#FFFFFF'} />
          Importer le fichier 
        </label>
      }
      <input ref={ref ? ref : null } type="file" name={name} onChange={(e) => onChange(e.target.files) } id={name} />
      {withErrors && <p className={styles['error-message']}>{error && error}</p>}
    </div>
  )
}
